import React from 'react'
import {
  Col,
  Container,
  Row,
  Table
} from 'reactstrap'
import { Filters, ListItem } from '.'
import { IgtLoader } from 'Atoms'

const CostCenterNetworksList = ({ onChangeFilter, modelList, isLoading }) => { 

  return (
    <Container fluid>
      <Row>
        <Col lg={{ size: 6, offset: 3 }}>
          <h1 className="text-center">Cost Center Networks Table</h1>
        </Col>
      </Row>
      <Row>
        <Col lg="12">
          {
            isLoading ?
              <IgtLoader isLoading={isLoading} />
              :
              <Table hover>
                <thead className='sticky-header'>
                  <tr>
                    <th>Identifier</th>
                    <th>Cost Center</th>
                    <th>Active</th>
                    <th>Expired</th>
                    <th>Replacement</th>
                    <th>Created</th>
                  </tr>
                </thead>
                <tbody>
                  
                <Filters
                  onChangeFilter={onChangeFilter}
                />
                  {
                    modelList && modelList.map((costCenterNetwork, i) => {
                      return (
                        <ListItem
                          modelListItem={costCenterNetwork}
                          key={i}
                          index={i}
                        />
                      )
                    })
                  }
                </tbody>
              </Table>
          }
        </Col>
      </Row>
    </Container>
  )
}

export default CostCenterNetworksList
